import authenticationModule from 'modules/authentication/presentation/authentication.module';
import checkoutModule from 'modules/checkout/presentation/checkout.module';
import customerModule from 'modules/customer/presentation/customer.module';
import employeeModule from 'modules/employee/presentation/employee.module';
import institutionalModule from 'modules/institutional/presentation/institutional.module';
import landingPagesModule from 'modules/landingPages/presentation/landingPages.module';
import schedulesModule from 'modules/schedules/presentation/schedules.module';
import sharedModule from 'shared/presentation/shared.module';

import { ModuleAggregator } from './aggregator';

type TModuleName =
  | 'shared'
  | 'landingPages'
  | 'checkout'
  | 'customer'
  | 'authentication'
  | 'schedules'
  | 'employee'
  | 'institutional';

const appModules = new ModuleAggregator<TModuleName>()
  .use('shared', sharedModule)
  .use('authentication', authenticationModule)
  .use('institutional', institutionalModule)
  .use('landingPages', landingPagesModule)
  .use('customer', customerModule)
  .use('checkout', checkoutModule)
  .use('schedules', schedulesModule)
  .use('employee', employeeModule)
  .build();

export default appModules;
